import { AdminListGridSkeleton } from '@/components/layout/admin-widget-skeleton'
import { PaneResponsiveCardGrid } from '@/components/layout/pane-responsive-card-grid'
import { PaneListEmptyState } from '@/components/layout/pane-list-empty-state'
import { Card, CardContent } from '@/components/ui/card'
import { UserX } from 'lucide-react'
import type { AdminUser } from '@/hooks/use-admin-users'
import { AdminUserCard } from '@/components/admin/admin-user-card'
import { EMPTY_STRING_SET } from '@/lib/empty-collections'
import type { ListSelection } from '@/lib/list-selection'

interface UserListProps {
  users: AdminUser[]
  isLoading: boolean
  onUserClick: (userId: string) => void
  onEditUser: (userId: string, user?: AdminUser) => void
  highlightedUserIds?: ReadonlySet<string>
  selection?: ListSelection
}

export function UserList({
  users,
  isLoading,
  onUserClick,
  onEditUser,
  highlightedUserIds = EMPTY_STRING_SET,
  selection,
}: UserListProps) {
  if (isLoading) {
    return <AdminListGridSkeleton count={6} ariaLabel="Loading users" />
  }

  if (users.length === 0) {
    return (
      <Card className="w-full">
        <CardContent>
          <PaneListEmptyState
            icon={<UserX aria-hidden />}
            title="No users found"
            description="Try adjusting your search criteria or create a new user."
          />
        </CardContent>
      </Card>
    )
  }

  return (
    <PaneResponsiveCardGrid>
      {users.map((user) => (
        <AdminUserCard
          key={user.id}
          user={user}
          highlighted={highlightedUserIds.has(user.id)}
          onUserClick={onUserClick}
          onEditUser={onEditUser}
          selected={selection?.selected.has(user.id)}
          onToggleSelect={selection?.onToggle}
        />
      ))}
    </PaneResponsiveCardGrid>
  )
}
